export default __webpack_public_path__ + "static/char-s-10-en-3d3fdd5f26e279eb648ed062fd9f2754.png";